import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

// Instructor Dashboard -> "Complete Lesson" (notes) dialog. Extracted from
// InstructorDashboard.js (props-driven, no behavior change).
export const LessonCompleteDialog = ({ open, onOpenChange, notesText, onNotesChange, onSave }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="lesson-complete-dialog">
      <DialogHeader>
        <DialogTitle>Complete Lesson</DialogTitle>
      </DialogHeader>
      <div className="space-y-1.5">
        <Label>Lesson notes (optional)</Label>
        <Textarea
          placeholder="What did you cover in this lesson?"
          value={notesText}
          onChange={(e) => onNotesChange(e.target.value)}
          data-testid="lesson-notes-input"
        />
      </div>
      <DialogFooter>
        <Button onClick={onSave} data-testid="lesson-notes-save-button">Save & Mark Complete</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
